export const environment = {
  subdomain: 'www.',
  url: 'https://www.oktopus.world',
  server: {
    url: 'https://api.oktopus.world'
  },
  dsn: 'http://cb9b845ae61a4c55ac6361b2c508104d@glitchtip.oktotech.net/3'
}
